<template>
    <div id="plan-feature">
        <div class="feature">
            <div class="feature-title">System Feature</div>
            <div class="feature-delete" @click="$emit('close')"><span class="material-icons">close</span></div>
        </div>
        <div class="feature-form">
            <div class="feature-item">
                <div class="feature-label">Max Disk Boyutu (Byte) (1GB = 1 * 1024 * 1024 * 1024)</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.maxDiskSize" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.chatAndNotification">Chat and Notification</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.chatBalloonCustomization">Chat Ballon Customization</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.removeSupsisLogo">Remove Supsis Logo</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.databaseConnection">Database Connection</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.singlePanelAccess">Singel Panel Access</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.ticketSystem">Ticket System</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.visitorStartChat">Ziyaretci Chat Başlatma</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.chatbotEntegration">Chatbot Entegrasyonu</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.teamChatEntegration">Takım Konuşması Entegrasyonu</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.whatsappEntegration">Whatsapp Entegrasyonu</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.instagramEntegration">Instagram Entegrasyonu</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.messengerEntegration">Messager Entegrasyonu</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.telegramEntegration">Telegram Entegrasyonu</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.mailEntegration">Mail Entegrasyonu</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.smsEntegration">SMS Entegrasyonu</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.webhookEntegration">WebHook Entegrasyonu</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.calenderEntegration">Takvim Entegrasyonu</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.taskManagementEntegration">Task Yönetimi</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.dataProtect">Veri Güvenliği</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.accessAllAgent">Tüm Temsilciler için Erişim</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.readyContents">Hazır İçerikler</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.allEntegrations">Tüm Entegrasyonlar</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.permissionControl">Yetkilendirme Özellikleri</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.autoRezervation">Otomatik Rezervasyon</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.flexibleBilling">Esnek Faturalandırma</a-checkbox>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { FeatureItems, Features } from "./index";

export default {
    props: {
        value: {
            type: Object,
            default: {},
        },
        type: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        form: {},
        featureForm: {
            chatAndNotification: false,
            chatBalloonCustomization: false,
            removeSupsisLogo: false,
            databaseConnection: false,
            singlePanelAccess: false,
            ticketSystem: false,
            chatbotEntegration: false,
            teamChatEntegration: false,
            whatsappEntegration: false,
            instagramEntegration: false,
            messengerEntegration: false,
            telegramEntegration: false,
            accessAllAgent: false,
            visitorStartChat: false,
            dataProtect: false,
            readyContents: false,
            mailEntegration: false,
            smsEntegration: false,
            webhookEntegration: false,
            allEntegrations: false,
            calenderEntegration: false,
            taskManagementEntegration: false,
            permissionControl: false,
            autoRezervation: false,
            flexibleBilling: false,
            maxDiskSize: 0,
        },
    }),
    mounted() {
        this.form = this.$_.cloneDeep(this.value);
        const feature = this.form.features.find((x) => x.type === FeatureItems.SYSTEM);
        this.featureForm = feature || this.featureForm;
    },
    watch: {
        form: {
            handler(newVal, oldVal) {
                if (!this.$_.isEqual(this.value, oldVal)) {
                    this.$emit("input", newVal);
                }
            },
            deep: true,
        },
        featureForm: {
            handler(v) {
                const response = { type: FeatureItems.SYSTEM, ...this.featureForm };
                response[Features.SYSTEM.MAX_DISK_SIZE] = +v.maxDiskSize || 0;
                const feature = this.form.features.findIndex((x) => x.type === FeatureItems.SYSTEM);
                if (feature < 0) {
                    this.form.features = [...this.form.features, response];
                } else {
                    this.form.features.splice(feature, 1, response);
                }
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
$bg-color: #ec4b1d;

#plan-feature {
    margin-top: 20px;

    .feature {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .feature-title {
            font-weight: bold;
            font-size: 16px;
        }

        .feature-delete {
            background-color: $bg-color;
            padding: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 2px;
            cursor: pointer;

            span {
                font-size: 14px;
                color: white;
            }
        }
    }
}
</style>
